import { Injectable } from '@angular/core';
import { environment } from '@app/../environments/environment';

export type AuthMode = 'identityServer' | 'openiddict';

export type AuthRuntimeConfig = {
  authMode: AuthMode;
  authority: string;
  clientId: string;
  scope: string;
};

// Profil d'execution et configuration d'authentification rendus par l'API au demarrage.
@Injectable({ providedIn: 'root' })
export class RuntimeProfileService {
  private profile = 'standard';
  private authConfig: AuthRuntimeConfig | null = null;

  // Appele par l'initialiseur d'application, avant tout routage.
  public async load(): Promise<void> {
    try {
      const response = await fetch(`${environment.apiBaseUrl}/api/runtimeProfile`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const body = await response.json();
      if (typeof body?.runtimeProfile === 'string') this.profile = body.runtimeProfile;
      if (
        (body?.authMode === 'identityServer' || body?.authMode === 'openiddict') &&
        typeof body?.authority === 'string' &&
        typeof body?.clientId === 'string' &&
        typeof body?.scope === 'string'
      ) {
        this.authConfig = {
          authMode: body.authMode,
          authority: body.authority,
          clientId: body.clientId,
          scope: body.scope,
        };
      }
    } catch {
      // API injoignable : on reste sur "standard".
    }
  }

  public get skipsAuthentication(): boolean {
    return this.profile === 'local';
  }

  public get auth(): AuthRuntimeConfig | null {
    return this.authConfig;
  }
}
